import { render, staticRenderFns } from "./UserSettingsButton.vue?vue&type=template&id=2eb7dfa6&scoped=true"
import script from "./UserSettingsButton.vue?vue&type=script&lang=ts"
export * from "./UserSettingsButton.vue?vue&type=script&lang=ts"
import style0 from "./UserSettingsButton.vue?vue&type=style&index=0&id=2eb7dfa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb7dfa6",
  null
  
)

export default component.exports